import type { SVGProps } from "react";
const SvgCancel01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M15.834 4.167 4.167 15.833m0-11.666 11.667 11.666"
    />
  </svg>
);
export default SvgCancel01;
